import * as React from "react";
import darken from "polished/lib/color/darken";
import styled, { css } from "../../../styled/index";
import {CS} from "../../../styles";

export const ItemListWrapper = styled("div")`
  width: 100%;
`;

export const ItemListContent = styled("div")`
  position: relative;
  width: 100%;
  border-radius: 3px;
  ${CS.shadow.med.one}
  > div {
    &:first-child {
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    &:last-child {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      border-bottom: none;
    } 
  }
`;

export const ItemListItem = styled("div")`
  width: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
  transition: 0.26s all;
  background: white;
  border-bottom: 1px solid ${() => darken(0.1, "white")};
  &:hover {
    background: ${() => darken(0.02, "white")};
  }
`;
